import React from 'react';
import BaseQuestion from './BaseQuestion';
import { QUESTION_TYPES, QUESTION_CONFIGS } from '../../constants/question-types';

/**
 * Text-based question component (Short Text, Paragraph)
 */
const TextQuestion = ({
  question,
  questionIndex,
  onUpdate,
  onRemove,
  onMoveUp,
  onMoveDown,
  isFirst,
  isLast,
  isParagraph = false,
}) => {
  const questionType = isParagraph ? QUESTION_TYPES.PARAGRAPH : QUESTION_TYPES.SHORT_TEXT;
  const config = QUESTION_CONFIGS[questionType];

  const handleMinLenChange = (e) => {
    const currentMaxLen = question.config?.maxLen || config.limits.maxLen;
    const minLen = Math.max(config.limits.minLen, Math.min(parseInt(e.target.value) || config.limits.minLen, currentMaxLen));
    const updatedConfig = {
      ...question.config,
      minLen,
    };
    onUpdate(questionIndex, { config: updatedConfig });
  };

  const handleMaxLenChange = (e) => {
    const currentMinLen = question.config?.minLen || config.limits.minLen;
    const maxLen = Math.max(currentMinLen, Math.min(parseInt(e.target.value) || config.limits.maxLen, config.limits.maxLen));
    const updatedConfig = {
      ...question.config,
      maxLen,
    };
    onUpdate(questionIndex, { config: updatedConfig });
  };

  const minLen = question.config?.minLen || config.limits.minLen;
  const maxLen = question.config?.maxLen || (isParagraph ? 1000 : 100);

  return (
    <BaseQuestion
      question={question}
      questionIndex={questionIndex}
      onUpdate={onUpdate}
      onRemove={onRemove}
      onMoveUp={onMoveUp}
      onMoveDown={onMoveDown}
      isFirst={isFirst}
      isLast={isLast}
      questionType={questionType}
      questionTypeLabel={isParagraph ? 'Paragraph' : 'Short answer'}
      questionTypeIcon={isParagraph ? '📄' : '📝'}
    >
      <div className="mt-3 p-3 bg-light rounded border">
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">
              Min length:
              <input
                type="number"
                min={config.limits.minLen}
                max={maxLen}
                value={minLen}
                onChange={handleMinLenChange}
                className="form-control form-control-sm"
              />
            </label>
          </div>
          <div className="col-md-6">
            <label className="form-label">
              Max length:
              <input
                type="number"
                min={minLen}
                max={config.limits.maxLen}
                value={maxLen}
                onChange={handleMaxLenChange}
                className="form-control form-control-sm"
              />
            </label>
          </div>
        </div>
      </div>
    </BaseQuestion>
  );
};

export default TextQuestion;
